import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=738cf76c&scoped=true"
import script from "./BottomNavigation.vue?vue&type=script&lang=ts"
export * from "./BottomNavigation.vue?vue&type=script&lang=ts"
import style0 from "./BottomNavigation.vue?vue&type=style&index=0&id=738cf76c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738cf76c",
  null
  
)

export default component.exports